import { css } from "@emotion/css";
import { Button, ExternalLink } from "@octopusdeploy/design-system-components";
import { space, text } from "@octopusdeploy/design-system-tokens";
import { useState } from "react";
import { AddArgoCDInstanceDialog } from "~/areas/infrastructure/components/ArgoCDInstances/AddArgoCDInstanceDialog";
import ArgoImage from "~/components/Actions/argocd/ArgoIcon.svg";
const styles = {
    centeringFlexbox: css({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        margin: space[32],
    }),
    textBox: css({
        display: "flex",
        flexDirection: "column",
        gap: space[8],
        marginBottom: space[24],
        alignItems: "center",
    }),
    headingLine: css({
        font: text.heading.small,
        alignContent: "center",
    }),
    descriptionLine: css({
        font: text.body.regular.medium,
        alignContent: "center",
    }),
    horizontalGroup: css({
        display: "flex",
        flexDirection: "row",
        width: "100%",
        gap: space[16],
        justifyContent: "center",
    }),
};
type CreateArgoCDGatewayProps = {
    spaceId: string;
    refetch: () => void;
};
export const CreateArgoCDGateway = (props: CreateArgoCDGatewayProps) => {
    const { spaceId, refetch } = props;
    const [showAddDialog, setShowAddDialog] = useState(false);
    const handleDialogOnClose = (wasGatewayInstalled: boolean) => {
        setShowAddDialog(false);
        // if we installed a gateway, reload the gateway list
        if (wasGatewayInstalled) {
            refetch();
        }
    };
    return (<>
            <div className={styles.centeringFlexbox}>
                <img src={ArgoImage} alt="ArgoCD Icon" style={{ width: 100, height: 100 }}/>
                <div className={styles.textBox}>
                    <div className={styles.headingLine}>You don't have any Argo CD instances to preview yet</div>
                    <div className={styles.descriptionLine}>Start by clicking on Add Argo CD Instance.</div>
                </div>
                <div className={styles.horizontalGroup}>
                    <Button importance={"primary"} label={"Add Argo CD Instance"} onClick={() => setShowAddDialog(true)} opensInNewTab={true}/>
                    <ExternalLink href={"./"}>Docs: Argo CD</ExternalLink>
                </div>
            </div>
            <AddArgoCDInstanceDialog open={showAddDialog} onClose={handleDialogOnClose} spaceId={spaceId} showProjectSelection={false}/>
        </>);
};
